<template>
  <div class="zj-moble-app-page">
      {{Msg}}
  </div>
</template>

<script>


import WebApis from "../../apis";
import { MessageBox } from 'mint-ui';

export default {
  name: "Home",
  controller: "UI",
  action: "Home",
  authorizeurl:"",
  props: {
    query: {
    }
  },
  data: function() {
    return {
      userAgent:"",
      browser:"",
      Msg:"",
      url:"",
      businesscode:"",
      childbusinesscode:""
    };
  },
  created() {
    this.Init();
  },
  methods: {
    Init() {
      this.userAgent=navigator.userAgent.toLowerCase();

      this.businesscode = this.$route.query.BusinessCode;
      this.childbusinesscode = this.$route.query.ChildBusinessCode;

      if(this.userAgent.match(/Alipay/i)=="alipay")
      {
           this.GetAuthorAliPayUrl();
      }
      else if(this.userAgent.match(/MicroMessenger/i)=="micromessenger")
      {
           this.GetAuthorWxUrl();
      }
      else
      {
          this.Msg="请使用支付宝和微信扫描二维码";
      }
    },
    GetAuthorWxUrl()
    {
      let BusinessAuthor={
        BusinessCode:this.businesscode,
        ChildBusinessCode:this.childbusinesscode
      }

      return new WebApis.BusinessPayOrderApi()
            .AuthorWxUrl(BusinessAuthor).then((res)=>{
                if (res.data) {
                  this.url=res.data.Data;
                  var timestamp=new Date().getTime();
                  this.url=this.url.replace("{$state}",timestamp);
                  console.log("url",this.url);

                  window.location.href=this.url;
                }
            }).catch((e) => {
              console.log("打开支付页面失败!",e);
              MessageBox({
                title: '提示',
                message: '打开支付页面失败!',
                showCancelButton: true
              });
            return false;
          });
    },
    GetAuthorAliPayUrl()
    {
      let BusinessAuthor={
        BusinessCode:this.businesscode,
        ChildBusinessCode:this.childbusinesscode
      }

      return new WebApis.BusinessPayOrderApi()
            .AuthorAliPayUrl(BusinessAuthor).then((res)=>{
                if (res.data) {
                  this.url=res.data.Data;
                  window.location.href=this.url;
                }
            }).catch((e) => {
              console.log("打开支付页面失败!",e);
              MessageBox({
                title: '提示',
                message: '打开支付页面失败!',
                showCancelButton: true
              });
            return false;
          });
    }
  },
  computed: {
   
  }
};
</script>